export const formSectionStyles = {
	divider: {
		'&:first-of-type': { display: 'none' }
	},
	root: (isVisible: boolean) => ({
		display: isVisible ? 'flex' : 'none',
		flexDirection: 'column',
		gap: 1.5
	}),
	content: {
		display: 'grid',
		gap: 1.5
	}
};
